import "./todayLine.scss";

import PropTypes from "prop-types";
import React, { PureComponent } from "react";

const TODAY_LINE_TITLE = "Now";

class TodayLineHeaderView extends PureComponent {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    let classNames = "todayLineHeader";

    return (
      <div className={classNames} style={this.props.style}>
        {TODAY_LINE_TITLE}
      </div>
    );
  }
}

TodayLineHeaderView.propTypes = {
  style: PropTypes.object.isRequired
};

export default TodayLineHeaderView;
